var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$slots.default
      ? _c(
          "span",
          {
            attrs: { role: "button", tabindex: "0" },
            on: {
              click: _vm.openModal,
              keydown: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                  return _vm.openModal.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  )
                    return null
                  $event.preventDefault()
                  return _vm.openModal.apply(null, arguments)
                },
              ],
            },
          },
          [_vm._t("default")],
          2
        )
      : _c(
          "button",
          {
            staticClass: "btn btn-outline-dark btn-sm",
            attrs: { type: "button" },
            on: { click: _vm.openModal },
          },
          [_c("i", { staticClass: "fas fa-search" })]
        ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "modal",
        staticClass: "modal fade",
        attrs: {
          id: "searchModal",
          tabindex: "-1",
          "aria-labelledby": "searchModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-scrollable modal-lg" },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.query,
                        expression: "query",
                      },
                    ],
                    ref: "search_input",
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t("Which topic are you looking for?"),
                      "aria-label": _vm.$t("Search"),
                      "aria-describedby": "button-addon2",
                    },
                    domProps: { value: _vm.query },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.query = $event.target.value
                        },
                        function ($event) {
                          return _vm.debouncedSearch()
                        },
                      ],
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("button", {
                  staticClass: "btn-close ms-2",
                  attrs: {
                    type: "button",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c(
                  "div",
                  [
                    _c(
                      "transition-group",
                      { attrs: { name: "component-fade" } },
                      [
                        _vm.message
                          ? _c("div", { key: "00", staticClass: "small" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.message) +
                                  "\n              "
                              ),
                            ])
                          : !_vm.query &&
                            !_vm.loading &&
                            !_vm.message &&
                            !_vm.recentSearches.length
                          ? _c(
                              "div",
                              {
                                key: "03",
                                staticClass: "text-center py-5 text-muted",
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-search fa-2x mb-3 d-block opacity-25",
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "mb-1 fw-semibold text-dark" },
                                  [_vm._v(_vm._s(_vm.$t("Search for content")))]
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "small mb-0" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Find by title, description, author and tags"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            )
                          : _vm.showRecent
                          ? _c("div", { key: "01" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center mb-2",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "small text-muted" },
                                    [_vm._v(_vm._s(_vm.$t("Recent searches")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-link btn-sm p-0",
                                      attrs: { type: "button" },
                                      on: { click: _vm.clearRecentSearches },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.$t("Clear")) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.recentSearches, function (term) {
                                  return _c(
                                    "button",
                                    {
                                      key: term,
                                      staticClass:
                                        "list-group-item list-group-item-action py-2",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectRecent(term)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(term) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _c("div", { key: "02" }, [
                              _vm.results.courses?.length
                                ? _c(
                                    "div",
                                    {},
                                    _vm._l(
                                      _vm.results.courses,
                                      function (course) {
                                        return _c("div", { key: course.id }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "card mb-2 hover-bg-gray",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "row g-0" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-3" },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "img-fluid rounded-start",
                                                        attrs: {
                                                          src: _vm.imgUrl(
                                                            course.cover_photo
                                                          ),
                                                          alt: course.title,
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-9 d-flex align-items-center",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "card-body",
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "small fw-semibold text-dark stretched-link",
                                                              attrs: {
                                                                href: `/${course.slug}`,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    course.title
                                                                  ) +
                                                                  "\n                            "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }